module.exports = __webpack_public_path__ + "static/img/46.e72b2330.png";